export default function Mission() {
  return (
    <section
      id="mission"
      className="py-32 px-6 bg-[#050508] text-white relative overflow-hidden border-t border-white/5"
    >
      {/* Grid texture */}
      <div className="absolute inset-0 opacity-[0.03]" aria-hidden="true">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)`,
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-widest text-[#00D9FF]/60 mb-4 font-mono">
            // OPERATING_MANDATE
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight text-white">
            系統運作原則
          </h2>
          <p className="text-sm text-white/30 font-mono tracking-wider">
            我們不出售確定性。我們交付算法級精度。
          </p>
        </div>

        <div className="space-y-10">
          <div className="border-l-2 border-[#00D9FF]/40 pl-8">
            <h3 className="text-xl font-bold mb-3 text-white">
              我們不出售確定性
            </h3>
            <p className="text-base text-white/50 leading-relaxed">
              TWINODE 不是預言機。我們交付的是{' '}
              <strong className="text-white/80">
                算法級參數運算
              </strong>
              ——一份以天文學與統計規律為基礎的概率行為地圖。我們量化環境變量與認知傾向。我們不保證結果。
            </p>
          </div>

          <div className="border-l-2 border-[#00FF88]/40 pl-8">
            <h3 className="text-xl font-bold mb-3 text-white">
              算法負責運算。決策權歸你。
            </h3>
            <p className="text-base text-white/50 leading-relaxed">
              我們交付的是一份{' '}
              <strong className="text-white/80">
                高維度的時空概率矩陣
              </strong>
              。系統負責標示前方的結構性風險與流動性斷層，而最終是否扣下扳機的決策魄力，始終歸屬於您。
            </p>
          </div>

          <div className="border-l-2 border-[#FFD700]/40 pl-8">
            <h3 className="text-xl font-bold mb-3 text-white">主體能動性不可讓渡</h3>
            <p className="text-base text-white/50 leading-relaxed">
              即便系統將某一時段標記為{' '}
              <strong className="text-white/80">高摩擦窗口</strong>，
              你仍保有在該節點啟動關鍵決策的完整權力。TWINODE 提供的是額外的分析層——確保你在更完整的信息基礎上運作，而非一份預設指令。
            </p>
          </div>

          <div className="border-l-2 border-white/20 pl-8">
            <h3 className="text-xl font-bold mb-3 text-white">
              透明度是信任的架構
            </h3>
            <p className="text-base text-white/50 leading-relaxed">
              我們公開技術架構，並闡明每個運算節點背後的邏輯。你有權理解系統如何運作——而不僅僅是接受一個黑盒的輸出。{' '}
              <strong className="text-white/80">公開構建</strong>不是行銷姿態，這是我們的運營契約。
            </p>
          </div>
        </div>

        {/* Core Slogan */}
        <div className="mt-20 text-center">
          <div className="inline-block max-w-3xl border border-white/8 bg-white/[0.02] px-10 py-10 rounded-sm">
            <div className="text-4xl text-[#00D9FF]/20 mb-4 font-mono" aria-hidden="true">
              &quot;
            </div>
            <p className="text-xl font-light leading-relaxed mb-4 text-white/70">
              我們不預測命運。
              <br />
              我們只計算環境變量與行為機率。
            </p>
            <div className="text-[10px] font-mono tracking-widest text-white/20 mt-4">
              — TWINODE OPERATING COVENANT
            </div>
          </div>
        </div>

        {/* Core Values Grid */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-compass-3-line',
              color: '#00D9FF',
              title: '精度',
              desc: '天文級運算精確度',
            },
            {
              icon: 'ri-shield-check-line',
              color: '#00FF88',
              title: '透明度',
              desc: '開放架構 & 可驗證邏輯',
            },
            {
              icon: 'ri-user-heart-line',
              color: '#FFD700',
              title: '決策主權',
              desc: '決策權力始終歸屬於你',
            },
          ].map((item) => (
            <div key={item.title} className="text-center border border-white/6 bg-white/[0.02] p-6 rounded-sm">
              <div
                className="w-12 h-12 flex items-center justify-center text-xl mx-auto mb-4 border"
                style={{
                  borderColor: `${item.color}30`,
                  backgroundColor: `${item.color}10`,
                  color: item.color,
                }}
                aria-hidden="true"
              >
                <i className={item.icon}></i>
              </div>
              <div className="font-bold mb-2 text-white">{item.title}</div>
              <div className="text-xs text-white/30 font-mono">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
